import { IoMdCheckmark } from 'react-icons/io';
import { AiFillPlayCircle } from 'react-icons/ai'

interface ServicesProps {
    services: string[] | null;
    filename: string;
}

const ServicesIProvide:React.FC<ServicesProps> = ({services, filename}) => {

return (
    <div className='flex flex-col h-full'>
        
        {
            services ? 
            <h1 className='font-bold text-[15px]'>Services I Provide:</h1>
            : null
        }

        <div className='flex flex-col md:max-xl:space-y-0 space-y-1 mt-1'>

        {

            services ?
            Array.from(new Set(services)).slice(0, 3).map((service, i) => {
                return (
                <div className='md:max-xl:p-[2px] flex flex-row items-center space-x-1' key={i}>
                    <IoMdCheckmark className='text-[15px] text-[#0066a0]' />
                    <p className='text-[12px]'>{service}</p>
                </div>
                );
            })
            : null
            
        }
        </div>

        {

            services && services.length > 3 ?
            <div className='md:max-xl:p-[2px] flex flex-row items-center space-x-1 mt-1'>
                <AiFillPlayCircle className='text-[#0066a0]' />
                <a href={filename} className='text-[#0066a0] text-[12px]'><u>
                    +{services.length - 3} additional services 
                </u></a>
            </div>  
            : null

        }
    
    </div>
)

} 

export default ServicesIProvide